import { dateFrontConvert } from './functionHelpers';

export const ANALYSIS_SELECT_ORCHARD_MESSAGE =
  'Selecciona un huerto y presiona Filtrar para ver los resultados.';

export const getAnalysisOrchards = (userOrchards) =>
  Array.isArray(userOrchards)
    ? userOrchards.filter((orchard) => orchard?.statusAnalysis === true)
    : [];

export const getAnalysisTableLocalization = (localization, filter) => {
  if (filter?.orchardValue) {
    return localization;
  }

  return {
    ...localization,
    noRecordsToDisplay: ANALYSIS_SELECT_ORCHARD_MESSAGE,
    noResultsFound: ANALYSIS_SELECT_ORCHARD_MESSAGE,
  };
};

export const formatOptionalAnalysisDate = (value) => {
  if (!value) {
    return '--';
  }

  const normalizedValue = String(value).trim();

  if (!normalizedValue || normalizedValue.startsWith('1970-01-01')) {
    return '--';
  }

  try {
    return dateFrontConvert(normalizedValue);
  } catch (_error) {
    return '--';
  }
};
